import { render, staticRenderFns } from "./caseAskAndAnswer.vue?vue&type=template&id=61391073&lang=pug"
import script from "./caseAskAndAnswer.vue?vue&type=script&lang=js"
export * from "./caseAskAndAnswer.vue?vue&type=script&lang=js"
import style0 from "./caseAskAndAnswer.vue?vue&type=style&index=0&id=61391073&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports